let API_KEY = '7fd8d9350c069ae9828539818f9e416e';

module.exports = API_KEY;